import React, { useState } from 'react';
import Modal from 'react-responsive-modal';
import { makeStyles } from '@material-ui/core';
import { colorPalette } from '../../colorPalette';
const defaultProps = {
    withCloseIcon: false,
    isOpen: false,
    onCloseCallBack: () => undefined,
    overlayClosable: false,
    darkBgModal: false,
    withFullWidthBody: false,
    dataQa: '',
};
export const CustomModal = ({ withCloseIcon, isOpen, onCloseCallBack, overlayClosable, children, darkBgModal, withFullWidthBody, dataQa, }) => {
    const [open, setOpen] = useState(isOpen);
    const useStyles = makeStyles({
        overlay: {
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: darkBgModal ? 'rgba(0, 0, 0, 0.7)' : 'rgba(0, 0, 0, 0.3)',
            zIndex: 99999999,
            padding: 0,
        },
        closeIcon: {
            position: 'absolute',
            top: '16px',
            right: '24px',
            cursor: 'pointer',
            zIndex: 99999999999,
            background: 'rgba(255, 255, 255, 0.4)',
            borderRadius: '5px',
        },
        modal: {
            padding: 0,
            width: '500px',
            '@media screen and (max-width: 768px)': {
                height: '100vh',
                width: '100%',
                borderRadius: '0',
            },
        },
        body: {
            maxWidth: '1108px',
            height: 'auto',
            padding: 0,
            borderRadius: withFullWidthBody ? '8px' : '5px',
            background: colorPalette.white,
            boxSizing: 'border-box',
            webkitBoxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
            mozBoxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
            boxShadow: '0 3px 7px rgba(0, 0, 0, 0.3)',
            webkitBackgroundClip: 'padding-box',
            backgroundClip: 'padding-box',
            zIndex: 9999999999,
            width: 'inherit',
            '@media screen and (max-width: 768px)': {
                maxHeight: '100vh',
                height: 'fill-available',
                borderRadius: '0',
            },
        },
    });
    const classes = useStyles();
    const onCloseDefault = () => {
        setOpen(false);
        if (onCloseCallBack) {
            onCloseCallBack();
        }
    };
    const handleClose = () => {
        onCloseDefault();
    };
    return (React.createElement(Modal, { open: open, closeOnOverlayClick: overlayClosable, onClose: handleClose, showCloseIcon: withCloseIcon, classNames: {
            overlay: classes.overlay,
            closeButton: classes.closeIcon,
            modal: classes.modal,
        } },
        React.createElement("span", { className: classes.body, "data-qa": dataQa !== null && dataQa !== void 0 ? dataQa : null }, children)));
};
CustomModal.defaultProps = defaultProps;
